import { Tag, TagProps } from "antd";
import { useMemo } from "react";
import { TagColors, TagSizes, tagColor, tagSize } from "./utils/theme";

interface CustomTagProps extends TagProps {
  colors: TagColors;
  ghost?: boolean;
  size?: TagSizes;
}

/**
 * 태그 - 신규 theme 용
 * @param param0
 * @returns
 */
export const CustomTag: React.FC<CustomTagProps> = ({
  colors,
  ghost = false,
  style,
  size = "small",
  ...props
}) => {
  /**
   * 컬러 매핑
   */
  const color = useMemo(() => {
    const palette: { [k: string]: any } = { ...tagColor };

    if (colors) {
      return palette[colors] || undefined;
    }
    return undefined;
  }, [colors]);

  const sizes = useMemo(() => {
    const scale: { [k: string]: any } = { ...tagSize };

    if (size) {
      return scale[size] || undefined;
    }

    return undefined;
  }, [size]);

  return (
    <Tag
      {...(color && { color: ghost ? "transparent" : color[0] })}
      style={{
        fontWeight: 500,
        borderRadius: 100,
        borderColor: ghost ? color[2] : color[0],
        ...(color && { color: color[1] }),
        ...(sizes && {
          fontSize: sizes[0],
          lineHeight: sizes[1],
          padding: sizes[2],
        }),
        ...style,
      }}
      {...props}
    />
  );
};
